import './scss/style.scss'


import 'swiper/css';

import "@babel/polyfill";
// import './js/navigation';
import './js/header/index';
import './js/helpers/index';
import './js/accordion/index';
import './js/calculator/index';
import './js/helpers/selectWrapper';
import './js/fxCalculator/index';
import './js/oilCalculator/index';
import './js/natgasCalculator/index';
import './js/tabs/index';
import './js/broker-filter/index';
import './js/slider/index';
import './js/register/index';
// import './js/overlay/index';
// import './js/animation/index';

